<template>
  <div>
    <BaseTitle :title="$t('content.class_section')" :yearPeriode="titleData" />
    <div class="d-flex align-end flex-column" v-if="user.cerdasTypeId === 2 && type === 'teacher'">
      <strong
        @click="
          dialogPopUp = true;
          getListStudentAndTeacher();
          items.length > 0 ? (status = true) : '';
        "
        class="white--text add-class-section"
        >{{ $t('content.class_section_title') }}
      </strong>
    </div>
    <v-row v-if="(items.length && user.cerdasTypeId === 2) || (items.length && user.cerdasTypeId === null)">
      <v-col v-for="item in items" :key="item.classSectionId" md="4">
        <div class="class-item d-flex justify-space-between" @click="gotoPage(item)">
          <svg-icon icon="class" width="130" height="90" />
          <strong
            >{{ $t('menu.class') }} {{ item.classSectionName }} <br /><span class="tahun-ajaran"
              >{{ $t('form.schoolyear') }} {{ item.yearPeriode }}
            </span>
          </strong>
          <br />
          <template v-if="items.length && user.cerdasTypeId === 2 && type === 'teacher'">
            <div class="pa-5">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <span dark v-bind="attrs" v-on="on">
                    <svg-icon icon="ic-moreaction-black" class="mt-1" />
                  </span>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title class="text-dropdown" @click="editDetail(item)">{{ $t('edit') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="deleteable">
                    <v-list-item-title class="text-dropdown-delete" @click="dialogdelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
        </div>
      </v-col>
    </v-row>
    <div v-if="(!items.length && user.cerdasTypeId === 2) || (!items.length && user.cerdasTypeId === null)">
      <div class="succ-content">
        <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
        <h1 class="succ-heading">{{ $t(`nodata_title`) }}</h1>
        <div class="succ-content mb-8">
          {{ $t(type === 'student' ? `content.no_data_student` : type === 'parent' ? `content.no_data_parent` : 'nodata_body') }}
        </div>
      </div>
    </div>
    <!-- Dialog Class Section -->
    <v-dialog v-model="dialogPopUp" persistent max-width="800">
      <v-card>
        <v-card-title class="headline secondary white--text d-flex justify-space-between">
          <span>{{ $t(dialogTitle) }}</span>
          <v-checkbox color="green" dense :disabled="items.length > 0" @change="classSectionId ? changeStatusClassSection() : ''" v-model="status">
            <template v-slot:label>
              <span class="input__label">{{ $t('content.class_section') }}</span>
            </template>
          </v-checkbox>
        </v-card-title>
        <v-card-subtitle v-if="status === true" class="pa-10">
          <v-row>
            <v-col cols="12" md="4" class="py-0">
              <form-group :name="$t('content.classroom')">
                <template slot-scope="{ attrs }">
                  <v-text-field :value="titleData" disabled v-bind="attrs" :label="$t('content.classroom')" />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <form-group :name="$t('content.number_class')" :validator="$v.formInput.numberClass">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    number
                    type="number"
                    v-model="formInput.numberClass"
                    v-bind="attrs"
                    @input="$v.formInput.numberClass.$touch()"
                    @blur="$v.formInput.numberClass.$touch()"
                    :label="$t('content.number_class')"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="3" class="py-0">
              <form-group :name="$t('form.status')" :validator="$v.formInput.status">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-model="formInput.status"
                    v-bind="attrs"
                    @input="$v.formInput.status.$touch()"
                    @blur="$v.formInput.status.$touch()"
                    :label="$t('form.status')"
                    :items="lockItems"
                  />
                </template>
              </form-group>
            </v-col>
          </v-row>
          {{ $t('content.class_section_content') }}
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <div class="move-list">
                <div class="move-list-title mt-3">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.teacher_list')" single-line v-model="searchTeacher">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul v-if="filterTeacher.length">
                    <li v-for="item in filterTeacher" :key="item.userId">
                      <v-checkbox color="secondary" v-model="formInput.teachers" :value="item.userId" :label="`${item.fullName}`" />
                    </li>
                  </ul>
                  <NoData v-if="!filterTeacher.length" />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <div class="move-list">
                <div class="move-list-title mt-3">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.student_list')" single-line v-model="searchStudent">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul v-if="filterStudent.length">
                    <li v-for="item in filterStudent" :key="item.studentId">
                      <v-checkbox color="secondary" v-model="formInput.students" :value="item.studentId" :label="`${item.fullName}`" />
                    </li>
                  </ul>
                  <NoData v-if="!filterStudent.length" />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-subtitle v-else class="mt-10">
          <NoData />
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center mb-2 mr-2">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closePopup">{{ $t('back') }}</v-btn>
            <v-btn
              color="primary"
              v-if="status === true"
              class="btn-primary-custom"
              type="submit"
              :loading="loadingCreate"
              @click="submitClassSection"
              >{{ $t('submit') }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete Class -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDelete">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="loading" @click="deleteDetail">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';

export default {
  name: 'ClassSectionList',
  props: {
    type: {
      type: String
    }
  },
  components: {
    BaseTitle,
    NoData
  },
  validations: function() {
    return {
      formInput: {
        numberClass: { required },
        status: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      student: 'Auth/student',
      isAuthenticated: 'Auth/isAuthenticated',
      user: 'Auth/user'
    }),
    dialogTitle() {
      return this.classSectionId ? 'content.class_section_title_edit' : 'content.class_section_title';
    },
    filterStudent() {
      if (this.searchStudent) {
        return this.listStudent.filter(item => {
          return item.fullName.toLowerCase().startsWith(this.searchStudent.toLowerCase());
        });
      } else {
        return this.listStudent;
      }
    },
    filterTeacher() {
      if (this.searchTeacher) {
        return this.listTeacher.filter(item => {
          return item.fullName.toLowerCase().includes(this.searchTeacher.toLocaleLowerCase());
        });
      } else {
        return this.listTeacher;
      }
    },
    lockItems() {
      return [
        { text: this.$t('paginate.show'), value: true },
        { text: this.$t('content.hide'), value: false }
      ];
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateClassSection({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update Class Section' });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    }
  },
  watch: {
    student: {
      deep: true,
      handler() {
        if (this.isAuthenticated) {
          this.getData();
        }
      }
    }
  },
  data: () => ({
    status: false,
    loading: true,
    loadingCreate: false,
    dialogPopUp: false,
    dialogDelete: false,
    dialogPopUpStudent: false,
    dialogPopUpSuc: false,
    searchTeacher: '',
    searchStudent: '',
    formInput: {
      numberClass: '',
      status: '',
      teachers: [],
      students: []
    },
    listCourse: [],
    search: '',
    classSectionId: '',
    itemClass: '',
    statusModal: false,
    items: [],
    titleData: '',
    listStudent: [],
    listTeacher: [],
    deleteable: true,
    isSubmitted: false
  }),
  methods: {
    closePopup() {
      this.dialogPopUp = false;
      this.statusModal = false;
      this.formInput.teachers = [];
      this.formInput.students = [];
      this.formInput.numberClass = [];
      this.classSectionId = '';
      this.formInput.status = '';
      this.$v.$reset();
      this.status = false;
      if (localStorage.getItem('backMenu')) {
        const perems = { classId: this.$route.params.classId, courseId: this.$route.params.courseId };
        this.$store.dispatch(`ClassSection/updateStatusClassroomCourse`, { status: false, ...perems }).then(() => {
          const params = { courseId: this.$route.params.courseId };
          this.$router.push({ name: `TeacherMenuList`, params });
          localStorage.removeItem('backMenu');
        });
      }
    },
    getListStudentAndTeacher() {
      this.$store.dispatch('ClassSection/listStudent', { classId: this.$route.params.classId, courseId: this.$route.params.courseId }).then(res => {
        this.listStudent = res;
      });
      this.$store.dispatch('ClassSection/listTeacher', { classId: this.$route.params.classId, courseId: this.$route.params.courseId }).then(res => {
        this.listTeacher = res;
      });
    },
    getDataClass() {
      this.$store
        .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
        .then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res + ` ( ${resa.yearPeriode} ) `;
            });
          } else {
            this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
    },
    editDetail(item) {
      localStorage.removeItem('backMenu');
      this.$store.dispatch('ClassSection/getListDetail', { classSectionId: item.classSectionId }).then(res => {
        const params = { classId: this.$route.params.classId, courseId: this.$route.params.courseId };
        this.$store.dispatch(`ClassSection/getListClassSection`, { ...params }).then(resa => {
          this.status = resa.classSection;
        });
        Object.keys(this.formInput).forEach(formInput => {
          this.formInput[formInput] = res[formInput];
        });
        this.$store.dispatch('ClassSection/listStudentSection', { classSectionId: item.classSectionId }).then(resa => {
          this.listStudent = resa;
        });
        this.formInput.teachers = this.formInput.teachers.map(a => a.userId);
        this.formInput.students = this.formInput.students.map(a => a.studentId);
        this.statusModal = true;
        this.dialogPopUp = true;
        this.classSectionId = res.classSectionId;
      });
    },
    getData() {
      let action = '';
      switch (this.type) {
        case 'teacher':
          action = 'ClassSection/getList';
          break;
        case 'student':
          action = 'ClassSection/getListStudent';
          break;
        case 'parent':
          action = 'ClassSection/getListParent';
          break;
        case 'school-advisor':
          action = 'ClassSection/getListClassSectionList';
          break;
      }
      this.loading = true;
      this.$store
        .dispatch(action, { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
        .then(res => {
          if (res.length === 1) {
            this.deleteable = false;
          }
          if (res.length === 0 && this.user.cerdasTypeId === 2 && this.type === 'teacher') {
            if (this.isSubmitted) {
              const classId = this.$route.params.classId;
              this.$router.push({ name: 'TeacherCourseList', params: { classId } });
            } else {
              this.dialogPopUp = true;
              this.status = true;
            }
          }
          this.items = res;
        })
        .finally(() => (this.loading = false));
    },
    getCourselite() {
      this.loading = true;
      this.$store
        .dispatch(`CourseSchool/fetchListLite`, {
          search: this.search
        })
        .then(data => (this.listCourse = data))
        .finally(() => (this.loading = false));
    },
    getDataLite() {
      let action = '';
      switch (this.type) {
        case 'teacher':
          action = 'Class/fetchListLite';
          break;
        case 'student':
          action = 'Class/fetchListStudentLite';
          break;
      }
      this.loading = true;
      this.$store.dispatch(action, this.student).finally(() => (this.loading = false));
    },
    gotoPage({ classSectionId }) {
      switch (this.type) {
        case 'teacher':
          this.$router.push({ name: 'TeacherMenuSectionList', params: { classSectionId } });
          break;
        case 'parent':
          this.$router.push({ name: 'ParentSectionMenuSectionList', params: { classSectionId } });
          break;
        case 'student':
          this.$router.push({ name: 'StudentMenuSectionList', params: { classSectionId } });
          break;
        case 'school-advisor':
          this.$router.push({ name: 'AdvisorSectionMenuSectionList', params: { classSectionId } });
          break;
      }
    },
    dialogdelete(item) {
      this.itemClass = item;
      this.dialogDelete = true;
    },
    cancelDelete() {
      this.dialogDelete = false;
      this.itemClass = null;
    },
    deleteDetail() {
      this.loading = true;
      this.$store
        .dispatch('ClassSection/destroy', this.itemClass.classSectionId)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.dialogDelete = false;
          this.getListStudentAndTeacher();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    submitClassSection() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      if (!this.formInput.teachers.length && !this.formInput.students.length) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_status_Edit') });
      } else if (this.formInput.teachers.length && !this.formInput.students.length) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_student') });
      } else if (!this.formInput.teachers.length && this.formInput.students.length) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_teacher') });
      } else {
        this.loadingCreate = true;

        const payload = { ...(this.statusModal ? { id: this.classSectionId } : { ...this.$route.params }), ...this.formInput };
        this.$store
          .dispatch(`ClassSection/${this.statusModal === false ? 'createSection' : 'updateSection'}`, { payload })
          .then(({ data }) => {
            // if (this.statusModal === false) {
            this.$store
              .dispatch(`ClassSection/updateStatus`, { status: this.formInput.status, classSectionId: data.data.classSectionId })
              .then(() => {
                this.isSubmitted = true;
              });
            // }
            this.$store.dispatch('general/showSuccessNotification', data);
            this.getData();
          })
          .finally(() => {
            this.dialogPopUp = false;
            this.statusModal = false;
            this.formInput.teachers = [];
            this.formInput.students = [];
            this.formInput.numberClass = [];
            this.formInput.status = '';
            this.$v.$reset();
            this.dialogPopUp = false;
            this.loadingCreate = false;
            this.status = false;
            localStorage.removeItem('backMenu');
          });
      }
    },
    changeStatusClassSection() {
      this.$store.dispatch(`ClassSection/updateStatus`, { status: this.status, classSectionId: this.classSectionId }).then(() => {});
    }
  },
  created() {
    const params = { classId: this.$route.params.classId, courseId: this.$route.params.courseId };
    this.$store.dispatch(`ClassSection/getListClassSection`, { ...params }).then(resa => {
      this.status = resa.classSection;
    });
    this.getListStudentAndTeacher();
    this.getDataClass();
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  background: #fff;
  padding: 20px;
  cursor: pointer;

  &:hover {
    background: #f8f8f8;
  }
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}

.tahun-ajaran {
  color: #ce8800;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.fixed-card {
  position: absolute;
  bottom: 0;
  background-color: #ffffff;
  width: 74%;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
}

.join-class {
  background-color: #eef6fc;
  border-radius: 8px;
}

.text-join {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
}
.guide-card-text {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 13px;
  line-height: 14px;
  text-align: left;
}
.move-list {
  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 18em;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.input__label {
  color: white;
}
.add-class-section {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: yellow;
}
</style>
